<template>
  <div class="sear">
    <!-- <van-nav-bar
      title="搜索"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    /> -->
    <van-search
    style=" 
    position: fixed;
    top:0;
    width:100%;
    z-index:100000; "

      v-model="value"
      placeholder="请输入搜索关键词"
      @search="onSearch"
      @cancel="onCancel"
      @click="gosearch"
      shape="round"
      background="#39383e"
    >
      <!-- <template #action>
        <div @click="onSearch">搜索</div>
      </template> -->
      <template #left>
        <div
          class="back"
          @click="onClickLeft"
        >

          <van-icon
            size="0.5rem"
            name="arrow-left"
          />
        </div>
      </template>
    </van-search>
    
  <div class="head">
    <div class="img">
        <img :src="logo" alt="">
    </div>
   
  </div>
     <div class="nav-wrap">
      <div
        v-show="!oopupFlag"
        class="nav"
        ref="navsp"
      >
        <ul id="navul">
          <li
            :class="{ active: statusNav == index }"
            v-for="(item, index) in nav"
            :key="index"
            :id="index"
            @click="addClass(index)"
          >
          
            <span> {{ item.name }}</span>
          </li>
        </ul>
      </div>
    
    </div>
   
 
       <van-swipe
      :loop="false"
      ref="nav1sp"
      @change="movenav"
      
      :show-indicators="false"
    >
      <van-swipe-item>
        <!-- <index
          ref="0"
          @addres="addre"
        ></index> -->
    <div class="jiadi"></div>

        <div class="ss" ref="10">
          <div class="navc">
            <ul class="clearfix">
              <li  @click="goproduct(v.id)" v-for="v in navs" :key="v.id">
                <img :src="v.thumb" alt="">
                <p>{{v.name}}</p>
              </li>
            </ul>
            
          </div>
             <div
      class="sp"
      style=""
      v-if="$store.state.sonid==58"
    >
      <iframe
        frameborder="0"
        src="https://www.huokongjian.net/index/index/taishan.html"
        width="100%"
        height="100%"
        scrolling="no"
      ></iframe> 
    </div>
          <div class="nx-swipe">
 <van-swipe  :autoplay="2000" indicator-color="#000">
        <van-swipe-item
          v-for="(image, index) in images"
          :key="index"
          @click="goswipe(image.adv_url)"
        >
        
 <img
            class="imgss"
            :src="image.adv_img"
          />
         
       
        </van-swipe-item>
         <!-- <template #indicator>
    <div class="van-swipe__indicators custom-indicator">

    </div>
  </template> -->
      </van-swipe>
          </div>
          <div class="hot-t">
          <img src="../../assets/shop/01.png" alt="">

          </div>
          <div class="hot-s">
            <ul class="clearfix">
              <li  v-for="v in hot" :key="v.id" @click="gop(v.id)">
                <img :src="v.thumb" alt="">
                <p>{{v.name}}</p>
                <p>热卖爆品</p>
                <p><span>￥{{v.min_price}}</span>到手价</p>
              </li>
               
            </ul>
          </div>
          <div class="hot-t hot-t2">
          <img src="../../assets/shop/02.png" alt="">

          </div>
          <div class="b-img">
            <img :src="guang1.adv_img" alt="">
          </div>
          <div class="b-img">
            <img :src="guang2.adv_img" alt="">
          </div>
          <div class="b-img">
            <img :src="bimg.adv_img" alt="">
          </div>
        </div>
      </van-swipe-item>
      <!-- <van-swipe-item>
        <six ref="1"></six>
        <div class="ss" ref="11"></div>

      </van-swipe-item>

      <van-swipe-item>
        <Brands ref="2"></Brands>
        <div class="ss" ref="12"></div>

      </van-swipe-item>
      <van-swipe-item>
        <four ref="3"></four>
        <div class="ss" ref="13"></div>

      </van-swipe-item>
      <van-swipe-item>0
        <SuperMember ref="4"></SuperMember>
        <div class="ss" ref="14"></div>

        <five ref="4"></five>
      </van-swipe-item> -->
      <!-- <van-swipe-item>
      </van-swipe-item>
      <van-swipe-item>
        <seven ref="6"></seven>
      </van-swipe-item> -->
    </van-swipe>
    
  </div>
</template>
<script>
import Vue from 'vue'
import { NavBar, Search, Toast, Icon, Button,Swipe, SwipeItem,Tabbar, TabbarItem } from 'vant'
import Swiper from 'swiper'

Vue.use(NavBar).use(Search).use(Toast).use(Icon).use(Button).use(Swipe).use(SwipeItem).use(Tabbar).use(TabbarItem)
export default {
  created () {
    this.$store.state.pid=0
    this.$store.state.spid1=""
    this.$store.state.spid=""
    let li = JSON.parse(localStorage.getItem('searchlist'))
    console.log(this.$store.state.sonid)
    if (localStorage.getItem('searchlist')) {
      if (li.length == 0) {
      } else {
        this.flage = false
        this.searlist = li
      }    } else { }

 let i = Math.ceil(this.nav.length / 4)
    this.allNavHeight = 0.3 + 0.8 * i + 'rem'
    this.axios
            .get('swipers', { params: { store_id: this.$store.state.sonid } })
            .then((res) => {
              // console.log(res)
              this.images = res.data.data
            })
            .catch(function (error) {
              console.log(error)
            })
             this.axios.get('firstAd', { params: { store_id: this.$store.state.sonid } }).then(res => {
            if (res.data.code == 200) {
              this.guang1 = res.data.data
            }
          }).catch(ref => { })
          this.axios.get('secondAd', { params: { store_id: this.$store.state.sonid } }).then(res => {
            if (res.data.code == 200) {
              this.guang2 = res.data.data
            }
          }).catch(ref => { })
          this.axios.get('thirdAd', { params: { store_id: this.$store.state.sonid } }).then(res => {
            if (res.data.code == 200) {
              this.bimg = res.data.data
            }
          }).catch(ref => { })
          this.axios.get('getAllThreeClass', { params: { store_id: this.$store.state.sonid } }).then(res => {
            // console.log(res)
            if (res.data.code == 200) {
              this.navs = res.data.info.sort((a, b) => {
                return a.sort - b.sort
              })
            }
           
          }).catch(ref => { })
          this.axios.get('hotGoods', { params: { store_id: this.$store.state.sonid } }).then(res => {
            // console.log(res)
            res.data.data.forEach((v, i) => {
              if (i < 4) {
                this.hot.push(v)
              }
            });
          }).catch(ref => { })
          this.axios.get('getHeadLogo', { params: { store_id: this.$store.state.sonid } }).then(res => {
            // console.log(res)
            // res.data.data.forEach((v, i) => {
            //   if (i < 4) {
            //     this.hot.push(v)
            //   }
            // });
            this.logo=res.data.data.adv_img
          }).catch(ref => { })
  },
  data () {
    return {
      value: '',
      flage: true,
      logo:'',
      searlist: [],
      list: ["马六甲生态板", '拉法基生态板', '兔宝宝生态板', '泰山石膏板'],
      nav: [
        {
          name: '精选',
          id: 0,
        },
        {
          name: '所有产品',
          id: 1,
        },
        {
          name: '活动',
          id: 2,
        },
        {
          name: '搭配购',
          id: 3,
        },
        // {
        //   name: '超级会员专区',
        //   id: 4,
        // },
        // {
        //   name: '隔墙吊顶',
        //   id: 5,
        // },
        // {
        //   name: '五金建材',
        //   id: 6,
        // },
      ],
      //nav导航参数
      allFlag: true,
      navHeight: {
        height: 0,
      },
      cid: 0,
      oopupFlag: false,
      statusNav: 0,
      allNavHeight: 0,
      count: 0,
      btnFlag: false,
      bodyheight: 0,
      show: false,
      din: '',
      active:0,
      images:[],
      guang1:[],
      guang2:[],
      bimg:[],
      navs:[],
      hot:[]
    }
  },
   mounted () {
    // window.addEventListener('scroll', this.scrollToTop)
    // this.addClass(4)
    // this.$refs.nav1.swipeTo(2)
    // document.body.scrollBottom = 0
    this.$refs.nav1sp.swipeTo(0)
    // document.body.scrollTop = 0

    // this.addClass(0)
  },
  destroyed () {
    // window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    gosearch () {
      this.$router.push('search')
    },
    goproduct (id) {
      
      this.$router.push({
        name: 'brandproducts',
        query: { id ,shop:1}
      })
    },
    onClickLeft () {
      this.$router.push('/')
    },
    gop(id){
this.$router.push({ name: 'products', query: { id } })
    },
    onSearch (val) {
      if (val.trim() == '') {
        return
      }
      if (localStorage.getItem('searchlist')) {
        let list = JSON.parse(localStorage.getItem('searchlist'))
        list.push(val)
        localStorage.setItem('searchlist', JSON.stringify(list))
      } else {
        let list = []
        list.push(val)
        localStorage.setItem('searchlist', JSON.stringify(list))
      }
      this.$router.push({ name: 'productList', query: { id: val } })

    },
    onCancel () {
      Toast('取消');
    },
    go (v) {
      this.$router.push({ name: 'productList', query: { id: v } })
    },
    clear () {
      localStorage.setItem('searchlist', JSON.stringify([]))
      this.searlist = []
      this.flage = true
    },
      move (index) {
        // console.log(document.getElementById(index))
      let _id = document.getElementById(index)
      let distance = _id.offsetLeft - 140
      this.$refs.navsp.scrollLeft = distance
    },
    addClass (i) {
      this.statusNav = i
      this.$refs.nav1sp.swipeTo(i)
      this.move(i)
    },
    openAllClass () {
      if (this.oopupFlag) {
        this.navHeight.height = 0
      } else {
        this.navHeight.height = this.allNavHeight
      }
      this.oopupFlag = !this.oopupFlag
      // this.navHeight.height = this.allNavHeight
    },
    allAddClass (i) {
      this.statusNav = i
      this.navHeight.height = 0
      this.oopupFlag = !this.oopupFlag
      var self = this
      this.din = setTimeout(function () {
        self.move(i)
        self.$refs.nav1sp.swipeTo(i)
      }, 100)
    },
    closeAllClass () {
      this.navHeight.height = 0
      this.oopupFlag = false
    },
    movenav (i) {
     
    //   this.bodyheight = Object.values(this.$refs)[i+10].$el.offsetHeight
      this.statusNav = i
      this.move(i)
      this.backTop()
    },
    backTop () {
      document.documentElement.scrollTop=0

      // const that = this
      // let timer = setInterval(() => {
      //   let ispeed = Math.floor(-that.scrollTop / 5)
      //   document.documentElement.scrollTop = document.body.scrollTop =
      //     that.scrollTop + ispeed
      //   if (that.scrollTop === 0) {
      //     clearInterval(timer)
      //   }
      // }, 0)
    },
    scrollToTop () {
      const that = this
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 200) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    goc(v){
      if(v==1){
      this.$router.push({ name: 'shopc', query: { id: 1 } })

      }

    }
  }
}
</script>
<style lang="less" scoped>
.custom-indicator {
    // position: absolute;
    // right: 5px;
    // bottom: 5px;
    // padding: 2px 5px;
    // font-size: 12px;
    // background: rgba(0, 0, 0, 0.1);
  }
.sear {
  padding-top: 1.3rem;
  background-color: #f7f8fa;
  height: 100%;
}
.back {
  padding: 0.1rem 0.2rem 0 0;
  color: #fff;
}
.head{
    .img{
        width: 100%;
       
    }
    background-color: #39383e;
    padding-left: 0.2rem;
    height: 1.8rem;
   
}
.but {
  padding: 0 10%;
}
.sp {
  width: 100%;
  height: 5.6rem;
  overflow: hidden;
  position: relative;
  bottom: 0.8rem;
}
.sp::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.nav-wrap {
//   position: fixed;
//   top: 3rem;
  padding-left: 0.266667rem;
//   left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 999;
  height: 0.986667rem;
  background-color: #39383e;
  // background-color: #f99;

  .nav-wrap-all {
    width: 100%;
    height: 0.653333rem;
    padding-left: 0.2rem;
  }

 

  .nav {
    width: 70%;
    overflow-x: auto;
    background-color: #39383e;
    // background-color: #f99;
    color: #fff;
margin: 0 auto;

    ul {
      display: flex;
      white-space: nowrap;

      li {
        position: relative;
        padding: 0.1rem 0.3rem;
        span {
        //   color: #fff;
    font-size: 0.4rem;

        }
      }
      .hot {
        width: 0.8rem;
        height: 0.7rem;
        position: absolute;
        top: -0.1rem;
        right: -0.3rem;
        color: #f00;
        font-size: 0.4rem;
      }

      li.active {
        // background-color: #950f0e;
        border-top:0.1rem  solid #950f0e;
        // border-bottom-width: 0.2rem;
        // border-radius: 0.4rem;
        // color: #fff;
      }
    }
  }
}
.jiadi{
  height: 1.2rem;
  background-color: #39383e;
  z-index: 9;
}

.ss{
    // height: 15rem;
    width: 100%;
    position: relative;
    padding-bottom: 2.5rem;
    .navc{
      position: relative;
      top: -1rem;
      left: 2%;
      width: 96%;
      // height: 6rem;
      border-radius: 0.3rem;
      background-color: #fff;
      z-index: 1000;
      box-shadow: -1px 1px 5px -1px rgb(184, 183, 183);
      padding-bottom: 0.2rem;
      ul{
        padding: 0.2rem;
        // padding-bottom: 0.4rem;
        li{
        float: left;
        width: 18%;
        margin-top: 0.2rem;
        margin-left: 0.5rem;
        p{
          height: 0.6rem;
          padding-bottom: 0.4rem ;
          text-align: center;
          line-height: 0.8rem;
        //          display: -webkit-box;

         overflow: hidden;
        // white-space: normal !important;
        // text-overflow: ellipsis;
        // word-wrap: break-word;
        // -webkit-line-clamp: 1;
        // -webkit-box-orient: vertical;

        }
        }
      }
      
    }
    .nx-swipe{
      position: relative;
      top: -1rem;
    }
    .hot-t{
      width: 60%;
      margin: 0 auto;
    }
    .hot-s{
      ul{
        padding: 0.2rem;
        padding-left: 0.3rem;
        li{
          float: left;
          width: 45%;

          margin: 0.2rem;
          p{
          // overflow: hidden;

                 display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        padding:0 0.2rem;
        margin-top: 0.2rem;
        font-size: 0.43rem;
        span{
          font-size: 0.5rem;
          color: #f80100;
        }
          }
          p:nth-child(2){
            height: 0.9rem;
          }
          p:nth-child(3){
            color: #4f4f4f;
          }
        }
      }
    }
    .hot-t2{
      padding:0.5rem 0 ;
    }
    .b-img{
      margin: 0 auto;
      border-radius: 0.2rem;
      width: 94%;
      margin-top: 0.3rem;
    }
    // background-color: #b8201f;
}

</style>
